import { React, useEffect, useState } from "react";

import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useParams,
} from "react-router-dom";
import { useTranslation } from "react-i18next";

import Home from "./pages/Home";
import Aitools from "./pages/Aitools";
import Blog from "./pages/Blog";
import About from "./pages/About";
import Article from "./Blogs/Article";
import AitoolsComponent from "./pages/Aitools";

import Learning from "./pages/Learning";
import TimeSlotTable from "./pages/TimeSlotTable";
import Login from "./pages/WriteArticle";
import ContactHu from "./pages/ContactHu";
import ContactEn from "./pages/ContactEn";
import ContactDe from "./pages/ContactDe";
import ContactEs from "./pages/ContactEs";
import ContactFr from "./pages/ContactFr";
import WriteArticle from "./pages/WriteArticle";
import Koszonjuk from "./pages/Koszonjuk";
import Services from "./pages/Services";
import PageNotFound from "./components/PageNotFound";
import NotFound from "./components/404"; // Importáld az új komponenst
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsOfUse from "./components/TermsOfUse";
import CookiePolicy from "./components/CookiePolicy";
import Imprint from "./components/Imprint";
import TranslatedHeader from "./components/Header"; // Import the TranslatedHeader
import Footer from "./components/Footer"; // Assuming you have a footer
import BlogPostPage from "./Blogs/BlogPostPage";
import "bootstrap/dist/js/bootstrap.bundle.min"; // Bootstrap import
import "./App.css";

function App() {
  const { i18n } = useTranslation(); // 👈 ezt hozd be
  return (
    <Router>
      <TranslatedHeader key={i18n.language} />
      <Routes>
        <Route path="/" element={<Navigate to="/hu/Home" replace={true} />} />
        <Route path="/:lng/Home" element={<Home />} />
        <Route path="/:lng/Blog" element={<Blog />} />
        <Route path="/:lng/About" element={<About />} />
        <Route path="/:lang/Blog/:id" element={<BlogPostPage />} />
        <Route path="/:lng/Aitools" element={<Aitools />} />
        <Route path="/:lng/Learning" element={<Learning />} />
        <Route path="/:lng/Contact" element={<Contact />} />
        <Route path="/Login" element={<Login />} />
        <Route path="/article" element={<Article />} />
        <Route path="*" element={<NotFound />} />
        <Route path="/:lng/koszonjuk" element={<Koszonjuk />} />
        <Route path="/:lng/TermsOfUse" element={<TermsOfUse />} />
        <Route path="/:lng/Services" element={<Services />} />
        <Route path="/:lng/PrivacyPolicy" element={<PrivacyPolicy />} />
        <Route path="/:lng/CookiePolicy" element={<CookiePolicy />} />
        <Route path="/:lng/Imprint" element={<Imprint />} />
        <Route path="/WriteArticle" element={<WriteArticle />} />
        <Route path="/:lng/TimeSlotTable" element={<TimeSlotTable />} />
      </Routes>
      <Footer />
    </Router>
  );
}

// Contact dinamikus komponens
function Contact() {
  const { lng } = useParams();
  switch (lng) {
    case "hu":
      return <ContactHu />;
    case "en":
      return <ContactEn />;
    case "de":
      return <ContactDe />;
    case "es":
      return <ContactEs />;
    case "fr":
      return <ContactFr />;
    default:
      return <Navigate to="/en/Contact" replace={true} />;
  }
}

export default App;
